module.exports = __webpack_public_path__ + "img/amil.ca33fba0.png";